import { createApi } from "@reduxjs/toolkit/query/react";
import customBaseQuery from "../../../utils/customBaseQuery";
import { gql } from "graphql-request";

export const GetUserBySearchKey = createApi({
  reducerPath: "GetUserBySearchKey",
  baseQuery: customBaseQuery,
  endpoints: (builder) => ({
    getUserBySearchKey: builder.query({
      query: ({ key }) => {
        return {
          url: `/utility/users/${key}`,
          method: "GET"
        };
      },
      extraOptions: { service: "Utility" }
    }),
    searchByIdAndNameOrEmailPaginated: builder.query({
      query: ({ key, ids = [] }) => ({
        url: "/graphql",
        body: gql`
      query {
        searchByIdAndNameOrEmailPaginated(
          sortCriteria: { sortKey: "email", order: "ASC", pageNo: 1, pageCount: 10 }
          request: { key: "${key}", ids: ${JSON.stringify(ids)} }
        ) {
          timestamp
          error
          version
          data {
            notAvailable
            pageNo
            pageCount
            totalCount
            profiles {
              id
              employeeNumber
              email
              profileImageUrl
              supervisor
              enabled
              org
              lastworkingday
              name {
                fullName
                lastName
                firstName
                middleName
              }
            }
          }
        }
      }
    `
      }),
      extraOptions: { service: "PID" }
    }),
    // searchByIdAndNameOrEmailPaginated: builder.query({
    //   query: ({ key }) => ({
    //     url: "/graphql",
    //     body: gql`
    //       query {
    //         searchByIdAndNameOrEmailPaginated(
    //           request: { key: "${key}" }
    //           sortCriteria: {
    //             sortKey: "name"
    //             order: "ASC"
    //             pageNo: 1
    //             pageCount: 10
    //           }
    //         ) {
    //             data {
    //   profiles {
    //     id
    //     email
    //     name {
    //       fullName
    //     }
    //   }
    // }
    //         }
    //       }
    //     `,
    //   }),
    //   extraOptions: { service: "PID" },
    // }),
    getProfileByEmailIn: builder.query({
      query: ({ key }) => ({
        url: "/graphql",
        body: gql`
       query {
  getProfileByEmailIn(
    email:${key}
  ) {
    data {
    notAvailable
      profiles {
        id
        employeeNumber
        name {
          firstName
          lastName
          fullName
        }
        email
        supervisor
        enabled
        project {
          projectName
        }
        location {
          country
        }
      }
    }
  }
}
`
      }),
      extraOptions: { service: "PID" }
    })
  })
});

export const {
  useLazyGetUserBySearchKeyQuery,
  useLazySearchByIdAndNameOrEmailPaginatedQuery,
  useLazyGetProfileByEmailInQuery
} = GetUserBySearchKey;
